/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/play-icon/play-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=play-icon.component.css.map */
